/* @flow */

import api from '../api'

export const downloadOrderProductImages = (orders, format, transformations) =>
  api.post('/orders/download-images', {
    body: {
      format: format,
      orders: orders,
      transformations: transformations,
    },
  })
